const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
const usdWhole = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
});
/** "$140.00", or "$140" when the amount is whole dollars. */
export function formatUsd(cents) {
    return cents % 100 === 0 ? usdWhole.format(cents / 100) : usd.format(cents / 100);
}
/** Stripe's standard US card price, which Stripe takes from RydRes's balance on every card payment. */
export const STRIPE_CARD_PRICE = { bps: 290, fixedCents: 30, text: '2.9% + 30¢' };
/** RydRes's own fee on a ride paid by card, as the screens quote it. The server's is in PLATFORM_FEE_CENTS. */
export const RYDRES_CARD_FEE_CENTS = 100;
/** Stripe's fee on a card payment of this amount, rounded as Stripe rounds it, never more than the payment. */
export function stripeFeeCents(amountCents) {
    return Math.min(amountCents, Math.round((amountCents * STRIPE_CARD_PRICE.bps) / 10_000) + STRIPE_CARD_PRICE.fixedCents);
}
/** What comes out of a ride's card payment: Stripe's fee first, then RydRes's own, together never more than the payment. */
export function cardFees(amountCents, rydresCents = RYDRES_CARD_FEE_CENTS) {
    const stripeCents = stripeFeeCents(amountCents);
    return { stripeCents, rydresCents: Math.min(rydresCents, amountCents - stripeCents) };
}
/** What a driver reads under a card payment or a tip: the fees that came out, and what is left. Null until money has moved. */
export function cardFeeNote(p) {
    if (p.chargebackCents)
        return `The rider's bank took back ${formatUsd(p.chargebackCents)} in a dispute. The card fees stay charged.`;
    if (p.status === 'refunded')
        return p.stripeFeeCents ? `Stripe keeps its ${formatUsd(p.stripeFeeCents)} fee on a refund, so that is what this cost you.` : 'Every fee went back to you.';
    if (p.status !== 'succeeded' && p.status !== 'partially_refunded')
        return null;
    const fees = [p.stripeFeeCents ? `Stripe's ${formatUsd(p.stripeFeeCents)} fee` : '', p.feeCents ? `RydRes's ${formatUsd(p.feeCents)} fee` : ''].filter(Boolean).join(' and ');
    return `You keep ${formatUsd(p.netCents)}${fees ? ` after ${fees}` : ''}.`;
}
//# sourceMappingURL=money.js.map